import React from "react";
import { Box, Typography } from "@material-ui/core";
import { useTranslation } from "../hooks/useTranslation";
import {
  GENERATION_MODE_NEXT,
  GENERATION_MODE_STANDARD,
  GENERATION_MODE_PREMIUM,
  GENERATION_MODE_DEFAULT,
  GENERATION_MODES,
} from "../constants/generationModes";

const MODES = {
  NEXT: GENERATION_MODE_NEXT,
  STANDARD: GENERATION_MODE_STANDARD,
  PREMIUM: GENERATION_MODE_PREMIUM,
};

function GenerationModeSelector({ value = GENERATION_MODE_DEFAULT, onChange }) {
  const { t } = useTranslation("jobs");

  const handleSelect = (mode) => {
    if (onChange) {
      onChange(mode);
    }
  };

  return (
    <Box className="gen-mode-selector">
      {GENERATION_MODES.map((mode) => (
        <Box
          key={mode}
          className={`gen-mode-option ${
            value === mode ? "gen-mode-option--active" : ""
          }`}
          onClick={() => handleSelect(mode)}
        >
          <Box className="gen-mode-option-header">
            <Box
              className={`gen-mode-radio ${
                value === mode ? "gen-mode-radio--checked" : ""
              }`}
            >
              {value === mode && <Box className="gen-mode-radio-dot" />}
            </Box>
            <Typography className="gen-mode-option-title">
              {t(`contestacao.cellParams.generationMode.${mode}`)}
            </Typography>
            {mode === MODES.PREMIUM && (
              <Box className="gen-mode-badge-premium">Premium</Box>
            )}
          </Box>
          <Typography className="gen-mode-option-desc">
            {t(`contestacao.cellParams.generationMode.${mode}Description`)}
          </Typography>
        </Box>
      ))}

      <Typography className="gen-mode-disclaimer">
        {t("contestacao.cellParams.generationMode.disclaimer")}
      </Typography>
    </Box>
  );
}

GenerationModeSelector.MODES = MODES;

export default GenerationModeSelector;
